import { Accept } from 'react-dropzone';

/**
 * Что дропзона принимает по умолчанию.
 *
 * HEIC и HEIF стоят в списке намеренно, хотя показать их браузер не умеет:
 * разрешённый файл доходит до обработчика и получает объяснение, где переключить
 * формат съёмки. Запрещённый исчезал бы молча — а именно в этом формате снимает
 * айфон по умолчанию, то есть молчали бы мы чаще всего.
 */
export const IMAGE_ACCEPT: Accept = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/webp': ['.webp'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif'],
};

/** Форматы, которые мы принимаем только ради внятного отказа. */
const ONLY_TO_EXPLAIN = ['heic', 'heif'];

/** Расширения, которые для человека называются одинаково. */
const SAME_FORMAT: Record<string, string> = { jpeg: 'jpg' };

/** Как формат пишется в подсказке. */
const FORMAT_LABEL: Record<string, string> = { jpg: 'JPG', png: 'PNG', webp: 'WebP', gif: 'GIF', svg: 'SVG' };

/**
 * Список форматов для подписи под зоной — «PNG, JPG, WebP».
 *
 * Считается из того же `accept`, что уходит в `react-dropzone`, чтобы подпись не
 * могла разойтись с тем, что поле принимает на самом деле: прежняя была
 * захардкожена и обещала «png, jpg», умалчивая про webp.
 *
 * Форматы, которые мы берём только ради объяснения (HEIC), в подсказку не идут —
 * обещать их нельзя.
 */
export function describeFormats(accept: Accept = IMAGE_ACCEPT): string {
  const formats = Object.values(accept)
    .flat()
    .map((extension) => extension.replace(/^\./, '').toLowerCase())
    .map((extension) => SAME_FORMAT[extension] ?? extension)
    .filter((extension) => !ONLY_TO_EXPLAIN.includes(extension));

  return Array.from(new Set(formats))
    .map((extension) => FORMAT_LABEL[extension] ?? extension.toUpperCase())
    .join(', ');
}
